import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { Box } from "grid-styled";
import join from "../../../utils/join-path";
import { TabBar, TabLink } from "../../tabs";
import ReviewQueue from "./ReviewQueue";
import ProductionQueue from "./ProductionQueue";
import CertifiedQueue from "./CertifiedQueue";
import SalesDrawingQueue from "./SalesDrawingQueue";
import NgcQueue from "./NgcQueue";

const AdminDashboard = ({ match }) => (
  <Box pb={3} px={3}>
    <TabBar bordered>
      <TabLink to={join(match.url, "/queue")}>Review Queue</TabLink>
      <TabLink to={join(match.url, "/production")}>Production</TabLink>
      <TabLink to={join(match.url, "/certified")}>Certified Review</TabLink>
      <TabLink to={join(match.url, "/sales-drawings")}>Sales Drawings</TabLink>
      <TabLink to={join(match.url, "/ngc")}>NGC</TabLink>
    </TabBar>
    <Box pt={2}>
      <Switch>
        <Route path={`${match.path}/queue`} component={ReviewQueue} />
        <Route path={`${match.path}/production`} component={ProductionQueue} />
        <Route path={`${match.path}/certified`} component={CertifiedQueue} />
        <Route
          path={`${match.path}/sales-drawings`}
          component={SalesDrawingQueue}
        />
        <Route path={`${match.path}/ngc`} component={NgcQueue} />
        <Redirect from={match.path} to={`${match.path}/queue`} />
      </Switch>
    </Box>
  </Box>
);

export default AdminDashboard;



// WEBPACK FOOTER //
// ./src/components/admin/Dashboard/index.js